/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesFriendRequestStatusSchema } from "./friendRequestStatusSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesFriendRequestSchema = z.object({
  id: z.string().nullish(),
  requesterId: z.string().min(1),
  get requester() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  addresseeId: z.string().min(1),
  get addressee() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  get status() {
    return goodLuckCoreEntitiesFriendRequestStatusSchema.optional();
  },
  createdAt: z.optional(z.iso.datetime()),
  respondedAt: z.iso.datetime().nullish(),
});
